"use client";

import React from "react";
import { CircleCheck, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Service() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const bulletPoints = ["24/7 availability for immediate rental assistance", "Step-by-step guidance for app and station usage", "Dedicated account management for venue partners"];
  return <section id="service" className="bg-background py-16 md:py-24 overflow-hidden relative">
      {}
      <div className="absolute top-1/2 left-0 -translate-y-1/2 w-96 h-96 bg-primary/5 rounded-full blur-[100px] pointer-events-none" />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={leftRef} className={`relative transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="relative rounded-3xl overflow-hidden border border-border/50 bg-card/30 backdrop-blur-sm shadow-2xl">
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 to-transparent mix-blend-overlay" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586523/img/abstract_3d_battery_charging.png" alt="Abstract 3D illustration of a battery charging" className="w-full h-auto object-cover aspect-square md:aspect-[4/3] lg:aspect-square" />
            </div>
            {}
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-accent/20 rounded-full blur-2xl" />
          </div>

          {}
          <div ref={rightRef} className={`flex flex-col gap-8 transition-all duration-1000 ease-out delay-200 ${isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground">
                We are here to help
              </h2>
              <p className="text-lg text-muted-foreground max-w-xl">
                Whether you're an end-user needing a quick charge or a venue partner managing a station, our support team is ready to assist you.
              </p>
            </div>

            <ul className="space-y-5">
              {bulletPoints.map((point, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                  <div className="mt-1 bg-primary/10 p-1 rounded-full shrink-0">
                    <CircleCheck className="size-5 text-primary" />
                  </div>
                  <span className="text-foreground text-lg leading-relaxed">
                    {point}
                  </span>
                </li>)}
            </ul>

            <div className="pt-4">
              <Button size="lg" className="rounded-full px-8 h-14 text-base shadow-lg shadow-primary/20 hover:shadow-primary/40 transition-all">
                <MessageCircle className="mr-2 size-5" />
                Live Chat
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}